import { FC } from "react"
import cx from "classnames"
import Modal, { ModalProps } from "@/components/Modal"
import OutlineButton from "@/components/OutlineButton"
import Button from "@/components/Button"
import type { SearchCriteria } from "@/types/entities/search-criteria"

type Props = {
  className?: string
  data?: SearchCriteria
  onConfirm: (id: string) => void
} & ModalProps

const SearchCriteriaDuplicateConfirmModal: FC<Props> = ({
  className,
  open,
  onClose,
  data,
  onConfirm,
  ...rest
}: Props) => {
  if (!data) {
    return null
  }
  const handleConfirm = () => onConfirm(data._id)
  return (
    <Modal
      open={open}
      onClose={onClose}
      onSubmit={handleConfirm}
      className={cx("", className)}
      title={`Duplicate ${data.name}`}
      actions={
        <div className="flex gap-4">
          <OutlineButton
            onClick={onClose}
            className="text-black btn-sm w-[86px]"
            type="button"
          >
            Cancel
          </OutlineButton>
          <Button className="btn-sm min-w-[86px]" type="submit">
            Confirm
          </Button>
        </div>
      }
      {...rest}
    >
      <span className="text-sm">
        Make a copy of "
        <span className="font-semibold">{data.name.trim()}</span>"?
      </span>
    </Modal>
  )
}

export default SearchCriteriaDuplicateConfirmModal
